// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/layout/global.styl
// module id = 507
// module chunks = 0